import React from 'react';
import { motion } from 'framer-motion';
import { Phone, X } from 'lucide-react';
import OtpDialog from '../../lib/OtpDialog';

interface CustomerAuthProps {
  businessId: string;
  open?: boolean;
  onClose: () => void;
  onSuccess: (phone?: string) => void;
  defaultPhone?: string;
}

export function CustomerAuth(props: CustomerAuthProps) {
  // תמיד הצג את OtpDialog, אל תבדוק את props.open !== undefined
  return (
    <OtpDialog
      businessId={props.businessId}
      open={props.open}
      onClose={props.onClose}
      onSuccess={props.onSuccess}
      defaultPhone={props.defaultPhone}
    />
  );
}